<div>
        <!--<ngx-avatar size={{size}} name="{{name}}" *ngIf="showName"></ngx-avatar>-->
        <div class="profile-name" *ngIf="showName"
            [ngStyle]="{'background':'#'+backgroundColor,'width':size+'px','height':size+'px','line-height':size+'px', 'font-size': size / 3+'px'}">{{getInitial(name)}}</div>
        <div class="profile-pic" *ngIf="showPic"
            [ngStyle]="{'background-image': 'url('+profilePhoto+')','width':size+'px','height':size+'px'}"></div>
</div>